import Ajax from './Ajax'

const Order = {
  getOrders: (wallet, type, page = 1, pageSize = 20) => {
    const params = new URLSearchParams({ wallet, page, pageSize })
    if (type) params.append('type', type)
    return Ajax.get(`/orders?${params.toString()}`)
  },
  getMyStats: (wallet) => {
    return Ajax.get(`/orders/my-stats?wallet=${wallet}`)
  },
  createOrder: (data) => {
    return Ajax.post('/orders', { data })
  }
}

export default Order
